<template>
  <div v-show="loaded" class="my-inspectors">
    <vue-headful title="My Inspectors" />
    <h1 class="test-my-inspectors">MY INSPECTORS</h1>
    <hr />

    <Alert v-if="showSuccessAlert" type="success" @close="closeSuccessAlert">
      Thank you for rating {{ratedInspector}}.
    </Alert>

    <MyInspectorsLoader v-if="apiLoading" />
    <template v-if="apiLoaded">
      <TeamMemberList
        v-if="showList"
        :hg-members="inspectors"
        hg-link="rate"
        hg-parent-component="INSPECTORS" />
      <h2 v-else class="no-inspectors">You have no inspectors</h2>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Alert from '@/components/Shared/Alert.vue';
import BaseViewComponent from '@/components/Shared/BaseViewComponent.vue';
import MyInspectorsLoader from '@/components/Loaders/MyInspectorsLoader.vue';
import TeamMemberList from '../Shared/TeamMemberList.vue';

export default {
  name: 'hgInspectors',
  extends: BaseViewComponent,
  components: {
    Alert,
    TeamMemberList,
    MyInspectorsLoader,
  },
  mounted() {
    const { currentUser } = this.$store.state.User;
    this.initialHydration([
      this.$store.dispatch('Inspectors/loadInspectors', currentUser.legacyId),
    ]);
  },
  props: {
    ratedInspector: {
      type: String,
      default: '',
    },
    ratedSuccess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSuccessAlert: this.ratedSuccess,
    };
  },
  computed: {
    ...mapState({
      loaded: state => state.loaded,
    }),
    ...mapState('Inspectors', {
      inspectors: state => state.inspectors,
    }),
    showList() {
      return this.inspectors.length > 0;
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (!to.hash) { /* ignore anchor tags for scrolling */
      next();
    }
  },
  methods: {
    closeSuccessAlert() {
      this.showSuccessAlert = false;
    },
    load(id) {
      this.$store.dispatch('Inspectors/loadInspectors', id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';

.no-inspectors {
  padding-bottom: 50px;
  padding-top: 50px;
  text-align: center;
}

hr {
  border: solid 2px $theme-color-primary;
  margin-top: 40px;
  width: 100%;
}

@media all and (min-width: 655px) {
  .my-inspectors {
    padding: 50px;
  }
}
</style>
